export default "__VITE_ASSET__DShhIOBa__"